import React, { cloneElement, useState } from 'react';

import { NotificationType } from '../../constants/notification';
import { Modal } from '../modal/Modal';

interface IPopConfirmProps {
  children: any;
  title: string;
  bodyText: string;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  modalColor?: NotificationType;
  isLoading?: boolean;
  showConfirm?: boolean;
}

export const PopConfirm: React.FunctionComponent<IPopConfirmProps> = ({
  children,
  title,
  bodyText,
  onConfirm,
  isLoading,
  showConfirm = true,
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      {cloneElement(children, { onClick: () => setShow(true) })}
      <Modal
        show={show}
        title={title}
        bodyText={bodyText}
        onClose={() => setShow(false)}
        onConfirm={() => {
          onConfirm();
          setShow(false);
        }}
        isLoading={isLoading}
        showConfirm={showConfirm}
      />
    </>
  );
};
